import * as requestServices from "../request";

export const req = {
    getUsersData(url, firmId, branchId, globalUser) {
        return requestServices
            .get(`${url}?firmid=${firmId}&branchId=${branchId}&roleId=${globalUser}`)
            .then(data => data)
            .then(res => {
                return res;
            });
    },

    getLookupData(url, firmId) {
        return requestServices
            .get(url + "/" + firmId)
            .then(data => data)
            .then(res => {
                return res;
            });
    },
    saveGridChanges(url, data) {
        return requestServices
            .put(url, data)
            .then(data => {
                return data;
            })
            .then(res => {
                return res;
            });
    },

    updateBulkeditChanges(url, data) {
        return requestServices
            .put(url, data)
            .then(data => data)
            .then(res => {
                return res;
            });
    },

    updateUserAccountStatus(url, data) {
        return requestServices
            .put(url, data)
            .then(data => data)
            .then(res => {
                return res;
            });
    },

    updateNotifyPassword(url, data) {
        return requestServices
            .put(url, data)
            .then(data => data)
            .then(res => {
                return res;
            });
    },
    getStaffReportData(url, firmId) {
        return requestServices
            .get(url + "/" + firmId)
            .then(data => data)
            .then(res => {
                return res;
            });
    },
    getStaffLookupData(url, firmId) {
        return requestServices
            .get(url + "/" + firmId)
            .then(data => data)
            .then(res => {
                return res;
            });
    },
    getfirmLookupData(url, firmId) {
        return requestServices
            .get(url + "/" + firmId)
            .then(data => data)
            .then(res => {
                return res;
            });
    },
    updateStaffIntegratedData(url, firmId) {
        return requestServices
            .put(url + "/" + firmId)
            .then(data => data)
            .then(res => {
                return res;
            });
    },
    getfirmGracePeriodData(url, firmId) {
        return requestServices
            .get(url + "/" + firmId)
            .then(data => data)
            .then(res => {
                return res;
            });
    },
    getIntegrationPhData(url, firmId) {
        return requestServices
            .get(url + "/" + firmId)
            .then(data => data)
            .then(res => {
                return res;
            });
    },
    getLicenseDetails(url) {
        return requestServices
            .get(url)
            .then(data => data)
            .then(res => {
                return res;
            });
    },
};
